import { foundationBreadcrumbItemStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroBreadcrumbItemStyles = (context, definition) => css `
  ${foundationBreadcrumbItemStyles(context, definition)}
  :host {
    --neutral-foreground-rest: #18b2e3;
    --accent-foreground-rest: #f1f1f1;
    --accent-foreground-hover: #f1f1f1;
  }

  .separator {
    color: var(--neutral-stroke-rest);
  }
`;
